import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import reqwest from 'reqwest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import settings from '../../settings';
import DataContainer from '../../logic/dataContainer';
import Button from '../../components/Buttons/Button';
import Page from '../../components/Layout/Page';
import DashboardLinksMenu from '../../components/Dashboard/DashboardLinksMenu';
import Card from '../../components/Card';
import RideDetail from '../../components/RideDetail';
import Loader from '../../components/Loader';
import SessionContext from '../../contexts/SessionContext';
import usePageTitle from '../../hooks/usePageTitle';
import { useParams } from 'react-router';

const Rides = (props) => {
  const { t } = useTranslation();
  usePageTitle(t('ridesPage.title'));
  const { guid: option } = useParams();
  const { sessionData } = useContext(SessionContext);
  const [listLoading, setListLoading] = useState(true);
  const [tripList, setTripList] = useState();
  const [selectedTripOption, setSelectedTripOption] = useState({
    guid: '',
    userGuid: '',
    type: '',
  });

  const tripSelected = (trip) => {
    setSelectedTripOption(trip);
    window.scroll({
      top: 400,
      left: 0,
      behavior: 'smooth',
    });
  };

  // Load Trips (offer list)
  useEffect(() => {
    reqwest({
      method: 'GET',
      url: settings.offer.getList,
      data: {
        Token: sessionData?.token,
        UserGuid: sessionData?.userGuid,
        onlyTripOffers: 'false',
      },
    })
      .then((listResponse) => {
        const filteredTripList = new DataContainer(listResponse)
          .getMany('Entry')
          .filter((c) => c.Guid)
          .sort((a, b) => (a.SortDay < b.SortDay ? 1 : -1));
        setTripList(filteredTripList);
        setListLoading(false);
        if (filteredTripList.length) {
          const selectedOption = filteredTripList.find(
            (entry) => entry.Guid === option,
          );
          if (selectedOption === undefined || option === 'requests') {
            setSelectedTripOption({
              guid: filteredTripList[0].Guid,
              userGuid: filteredTripList[0].UserGuid,
              type: filteredTripList[0].Type,
            });
          } else {
            tripSelected({
              guid: option,
              userGuid: selectedOption?.UserGuid,
              type: selectedOption?.Type,
            });
          }
        }
      })
      .fail((_) => {
        setListLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="Rides">
      <Page className="ContentContainer--rides">
        <DashboardLinksMenu option={option} />
        <br />
        {listLoading ? (
          <Loader />
        ) : (
          <div
            className={`ContentSection-split ${
              selectedTripOption?.guid ? 'hideLeft' : 'hideRight'
            }`}
          >
            <div className="ContentSection-left">
              <h2 className="underline">{t('ridesPage.title')}</h2>
              {tripList?.map((entry) => {
                return (
                  <Card
                    key={entry.Guid}
                    entry={entry}
                    active={selectedTripOption?.guid === entry.Guid}
                    onClick={(guid) =>
                      tripSelected({
                        guid,
                        userGuid: entry.UserGuid,
                        type: entry.Type,
                      })
                    }
                  />
                );
              })}
              {!tripList?.length && (
                <div className="ContentSection-no_results">
                  {t('dashboard.lists.no_rides')}
                </div>
              )}
              <br />
              <Button align="center" to="/offer">
                {t('ridesPage.buttons.new')}
              </Button>
            </div>

            <div className="ContentSection-right">
              {selectedTripOption?.guid && (
                <Button
                  className="Back-Button"
                  shape="default"
                  onClick={() => {
                    setSelectedTripOption({
                      guid: '',
                      userGuid: '',
                      type: '',
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                  {t('ridesPage.buttons.backMobile')}
                </Button>
              )}
              <RideDetail
                tripGuid={selectedTripOption?.guid}
                type="Offer"
                userGuid={selectedTripOption?.userGuid}
              />
            </div>
          </div>
        )}
      </Page>
    </div>
  );
};

Rides.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      guid: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default Rides;
